(function () {
  if (customElements.get('complete-the-set-item')) return;

  class CompleteTheSetItem extends HTMLElement {
    constructor() {
      super();
      this.selects = Array.from(this.querySelectorAll('[data-cts-option-select]'));
      this.priceVariants = Array.from(this.querySelectorAll('[data-variant-price]'));
      this.addButton = this.querySelector('[data-cts-add]');
      this.addButtonText = this.addButton ? this.addButton.querySelector('[data-cts-add-text]') : null;
      this.quantityInput = this.querySelector('.quantity__input');
      this.errorEl = this.querySelector('[data-cts-error]');
      const variantsJson = this.querySelector('[data-cts-variants]');
      this.variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];

      this.selects.forEach((select) => select.addEventListener('change', () => this.updateVariant()));
      if (this.addButton) this.addButton.addEventListener('click', () => this.addToCart());

      this.updateVariant();
    }

    getSelectedOptionValues() {
      return this.selects
        .slice()
        .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
        .map((select) => select.value);
    }

    findVariant() {
      if (!this.variants.length) return null;
      if (!this.selects.length) return this.variants[0];
      const selected = this.getSelectedOptionValues();
      return (
        this.variants.find((variant) => variant.options.every((value, index) => value === selected[index])) || null
      );
    }

    updateVariant() {
      const variant = this.findVariant();
      this.currentVariant = variant;

      this.priceVariants.forEach((el) => {
        el.hidden = !(variant && String(variant.id) === el.dataset.variantPrice);
      });

      if (!this.addButton) return;

      if (variant) {
        this.addButton.dataset.variantId = variant.id;
        this.addButton.disabled = !variant.available;
        this.addButton.removeAttribute('aria-disabled');
        if (this.addButtonText) {
          this.addButtonText.textContent = variant.available
            ? this.addButton.dataset.addLabel
            : this.addButton.dataset.soldOutLabel;
        }
      } else {
        this.addButton.disabled = true;
        if (this.addButtonText) this.addButtonText.textContent = this.addButton.dataset.soldOutLabel;
      }

      this.dispatchEvent(
        new CustomEvent('cts:variant-change', { bubbles: true, detail: { item: this, variant } })
      );
    }

    setError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || '';
    }

    addToCart() {
      if (!this.currentVariant || !this.currentVariant.available || this.addButton.disabled) return;

      // With monogramming on, the button opens the monogram drawer instead;
      // the drawer does the add to basket.
      const monogramToggle = this.querySelector('[data-cts-monogram-toggle]');
      if (monogramToggle && monogramToggle.checked) {
        const monogramEl = this.querySelector('complete-the-set-monogram');
        if (monogramEl && typeof monogramEl.open === 'function') monogramEl.open();
        return;
      }

      this.setError('');

      const quantity = this.quantityInput ? parseInt(this.quantityInput.value, 10) || 1 : 1;
      const formData = new FormData();
      formData.append('id', this.currentVariant.id);
      formData.append('quantity', quantity);

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }

      this.addButton.setAttribute('aria-disabled', 'true');
      this.addButton.classList.add('loading');

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.setError(response.description || response.message || 'Couldn’t add this item to your basket.');
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'complete-the-set',
              productVariantId: this.currentVariant.id,
              cartData: response,
            });
          }

          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(response);
          }
        })
        .catch(() => {
          this.setError('Something went wrong adding this item. Please try again.');
        })
        .finally(() => {
          this.addButton.removeAttribute('aria-disabled');
          this.addButton.classList.remove('loading');
        });
    }
  }

  customElements.define('complete-the-set-item', CompleteTheSetItem);

  class CompleteTheSet extends HTMLElement {
    constructor() {
      super();
      this.media = this.querySelector('[data-cts-media]');
      this.mediaImage = this.media ? this.media.querySelector('img') : null;
      this.mediaCaption = this.querySelector('[data-cts-caption]');
      this.items = Array.from(this.querySelectorAll('[data-cts-item]'));

      this.items.forEach((item) => {
        item.addEventListener('mouseenter', () => this.setActiveItem(item));
        item.addEventListener('focusin', () => this.setActiveItem(item));
      });

      // Keep the server-rendered image until a real hover/focus.
    }

    setActiveItem(item) {
      if (!this.mediaImage || !item.dataset.image) return;
      if (this.mediaImage.src !== item.dataset.image) {
        this.mediaImage.src = item.dataset.image;
        this.mediaImage.srcset = item.dataset.imageSrcset || '';
        this.mediaImage.alt = item.dataset.imageAlt || '';
      }

      this.items.forEach((el) => el.classList.toggle('is-active', el === item));

      if (this.mediaCaption) this.mediaCaption.textContent = item.dataset.caption || '';
    }
  }

  customElements.define('complete-the-set', CompleteTheSet);
})();
